import { render, staticRenderFns } from "./deductSet.vue?vue&type=template&id=0490fc52&scoped=true&"
import script from "./deductSet.vue?vue&type=script&lang=js&"
export * from "./deductSet.vue?vue&type=script&lang=js&"
import style0 from "./deductSet.vue?vue&type=style&index=0&lang=css&"
import style1 from "./deductSet.vue?vue&type=style&index=1&id=0490fc52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0490fc52",
  null
  
)

export default component.exports